module.exports = __webpack_public_path__ + "img/left-rotate-icon.5f25583f.svg";